import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { sizes } from '../data/mockData';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
const EASE = [0.23, 1, 0.32, 1] as const;

/** /size-guide — a static, read-only guide to the three sizes. */
export function SizeGuide() {
  return <div className="w-full bg-paper" data-id="element-862" data-mp="1gu2rotifbzoa">
      <PageHero eyebrow="Size & Drink Guide" title="Three sizes. One of them is yours." intro="250ml, 350ml or 400ml — the right one depends on what you drink and how long you take over it. Here is the whole answer on one page." data-id="element-863" data-mp="1gqx1tc1z0tri">
        <Link to="/shop" className="type-cta inline-block rounded-full bg-coffee px-8 py-4 text-[11px] text-paper transition-colors hover:bg-pennant" data-id="element-864" data-mp="1vj78q7dhfxut">
          Shop all cups
        </Link>
      </PageHero>

      {/* ── THE THREE SIZES ──────────────────────────────────── */}
      <section className="mx-auto max-w-[1400px] px-6 py-20 md:py-24" data-id="element-865" data-mp="3af04v9hajnk0">
        <SectionHeading eyebrow="The sizes" title="250ml · 350ml · 400ml" subtitle="Same bamboo fibre body, same lid and sleeve system — only the volume changes." data-id="element-866" data-mp="35hhvxj39x8c0" />

        <div className="mt-14 grid gap-8 lg:grid-cols-3" data-id="element-867" data-mp="2vpm0kfsknwbh">
          {sizes.map((s, i) => <motion.article key={s.id} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.06,
          ease: EASE
        }} className="flex h-full flex-col overflow-hidden rounded-4xl border border-oat/70 bg-paper-warm" data-id="element-868" data-mp="2rq3cjb5gf54f" data-mpi={i}>
              <img src={s.image} alt={`An Ecoffee Cup in ${s.label}`} className="aspect-[4/3] w-full object-cover" data-id="element-869" data-mp="fyg824adjobo" />
              <div className="flex flex-1 flex-col p-8" data-id="element-870" data-mp="25g4p87s3rd7t">
                <div className="flex items-baseline justify-between gap-4" data-id="element-871" data-mp="25ejvgkdm3yb0">
                  <h3 className="type-display text-4xl text-coffee" data-id="element-872" data-mp="2a8xsssbu4fib">
                    {s.label}
                  </h3>
                  <span className="type-eyebrow text-[9px] text-coffee/45" data-id="element-873" data-mp="1vgdwobn3r8ad">
                    {s.imperial}
                  </span>
                </div>
                <p className="type-body mt-4 text-sm text-ink/70" data-id="element-874" data-mp="2o85w9xf169sb">{s.suits}</p>

                <p className="type-eyebrow mt-8 text-[9px] text-pennant" data-id="element-875" data-mp="2t6qwhwua8tgr">
                  Best for
                </p>
                <ul className="mt-4 flex flex-wrap gap-2" data-id="element-876" data-mp="2f5ek1vebz9zm">
                  {s.drinks.map(d => <li key={d} className="type-ui rounded-full border border-oat bg-paper px-3.5 py-1.5 text-xs text-ink/70" data-id="element-877" data-mp="2j6qau48xy19e">
                      {d}
                    </li>)}
                </ul>

                <p className="type-body mt-6 text-sm text-ink/55" data-id="element-878" data-mp="108k9as8yex8r">
                  {s.lifestyle}
                </p>

                <Link to={`/shop?size=${s.id}`} className="type-cta mt-auto inline-flex items-center gap-2 pt-8 text-[10px] text-coffee transition-colors hover:text-pennant" data-id="element-879" data-mp="v9h4n8wvyt1b">
                  Shop {s.label}
                  <ArrowRightIcon className="h-3 w-3" strokeWidth={1.5} data-id="element-880" data-mp="him0ub18v24l" />
                </Link>
              </div>
            </motion.article>)}
        </div>
      </section>
    </div>;
}